<template>
    <div class="logistics_detail">
        <nav-bar />
        <search-bar />
        <div class="main" v-if="loading">
            <div class="nav">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item >供应商订单</el-breadcrumb-item>
                    <el-breadcrumb-item>已发货</el-breadcrumb-item>
                    <el-breadcrumb-item>物流列表</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="info_box">
                <div class="fr ac fz12 mt30">
                    <div class="center order_list_item">产品信息</div>
                    <div class="center order_list_item">产品价格</div>
                    <div class="center order_list_item">购买数量</div>
                    <div class="center order_list_item">发货数量</div>
                    <div class="center fg">操作</div>
                </div>

                <el-divider></el-divider>

                <!--        列表-->

                <div class="order-list fz12">
                    <div
                        class="order-item mt20"
                        v-for="(item,index) in logistics_detail"
                        :key="index"
                    >
                        <!--                上-->
                        <div class="top fr ac">
                            <p>{{item.create_time}}</p>
                            <p class="ml10">{{item.logistics_name}}</p>
                            <p class="ml10">{{item.logistics_no}}</p>
                        </div>
                        <!--                中-->

                        <div class="fr middle">
                            <!-- 商品信息 -->
                            <div class="order">
                                <div
                                    class="fr order_left"
                                    v-for="(goods,i) in item.orderLogisticsGoodsBeans"
                                    :key="i"
                                >
                                    <div class="fr afs pl10 pr20 pt20 pb20 order_list_item">
                                        <el-image
                                            class="goods_img fs mr10"
                                            :src="goods.goods_img"
                                            alt
                                        />
                                        <p class>{{goods.goods_name}} {{goods.goods_standard_name}}</p>
                                    </div>
                                    <div class="center order_list_item">￥{{goods.goods_price}}</div>
                                    <div class="center order_list_item">{{goods.goods_num}}</div>
                                    <div class="center order_list_item">{{goods.send_count}}</div>
                                </div>
                            </div>
                            <!-- 操作 -->
                            <div class="fc jc ac fg fs operating">
                                <el-popover placement="right" width="400" trigger="click">
                                    <el-timeline>
                                        <el-timeline-item
                                            placement="top"
                                            v-for="(activity, index) in details"
                                            :key="index"
                                            :timestamp="activity.ftime.substr(0,activity.logistics_time.length-2)"
                                        >{{activity.context}}</el-timeline-item>
                                    </el-timeline>
                                    <el-button
                                        type="text"
                                        size="mini"
                                        slot="reference"
                                        @click.native="getOrderLogisticsDetails(item.order_logistics_id)"
                                    >查看物流</el-button>
                                </el-popover>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-bar />
    </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import SearchBar from "@/components/SearchBar";
import FooterBar from "@/components/FooterBar";
export default {
    props: {},
    data() {
        return {
            logistics_detail: {},
            loading: false,
            details: []
        };
    },
    created() {
        this.getOrderLogisticss();
    },
    mounted() {},
    watch: {},
    methods: {
        receiveOrderLogistics(id) {
            this.post("orderInterfaces/v1.0/receiveOrderLogistics", {
                order_id: this.$route.query.id,
                order_logistics_id: id
            }).then(res => {
                this.$message({
                    message: res.data,
                    type: "success"
                });
                this.getOrderLogisticss();
            });
        },
        // 订单详情
        getOrderLogisticss() {
            this.post("orderInterfaces/v1.0/getOrderMerchantsLogisticss", {
              order_merchants_id: this.$route.query.order_merchants_id
            }).then(res => {
                this.logistics_detail = res.data;
                this.loading = true;
            });
        },
        getOrderLogisticsDetails(order_logistics_id) {
            this.post("orderInterfaces/v1.0/getOrderLogisticsDetails", {
              order_logistics_id
            }).then(res => {
                this.details = res.data;
            });
        }
    },
    components: { NavBar, SearchBar, FooterBar }
};
</script>

<style lang="scss">
.logistics_detail {
    .main {
        width: 1200px;
        margin: 0 auto;
        padding: 20px 0;
        .nav {
            background-color: #fff;
            padding: 20px;
            margin-bottom: 20px;
        }
        .info_box {
            background-color: #fff;
            padding: 20px;
            .order_list_item {
                &:nth-of-type(1) {
                    width: 400px;
                }
                &:nth-of-type(2) {
                    width: 200px;
                }
                &:nth-of-type(3) {
                    width: 200px;
                }
                &:nth-of-type(4) {
                    width: 200px;
                }
            }
            .order-list {
                .order-item {
                    border: 1px solid #e5e5e5;
                    .order_list_item {
                        border-right: 1px solid #e5e5e5;
                        &:nth-of-type(4) {
                            border-right: none;
                        }
                    }
                    .top {
                        background-color: #f0f6ff;
                        padding: 14px;
                    }
                    .middle {
                        .order {
                            .order_left {
                                height: 120px;
                                border-right: 1px solid #e5e5e5;
                                border-bottom: 1px solid #e5e5e5;
                                &:last-child {
                                    border-bottom: none;
                                }
                                .goods_img {
                                    width: 80px;
                                    height: 80px;
                                }
                            }
                            .operating {
                                .el-button {
                                    font-weight: normal;
                                }
                                p {
                                    margin-top: 10px;
                                    &:nth-of-type(1) {
                                        margin-top: 0;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/me/merchantsOrder/logistics.vue